var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgLeftYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 705,
    height: 2764,
    viewBox: "0 0 705 2764",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_1_493)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.5 2072.5C-34.1 2245.3 -82.1667 2405.5 -90 2464L1.5 300C28.3333 420.333 103.8 703 191 871C278.2 1039 369.667 1064.67 404.5 1056.5C316.667 1110.5 120.8 1261.3 40 1432.5C-61 1646.5 257.5 1856.5 95.5 2072.5Z",
    fill: "#FFA500"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1_493",
    x: -390,
    y: 0,
    width: 1094.5,
    height: 2764,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur_1_493"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgLeftYellow);
export default __webpack_public_path__ + "static/media/bg-left-yellow.17d356358bf86fdd94f09d54b170beb4.svg";
export { ForwardRef as ReactComponent };